<template>
  <div class="specialPageDetail" v-if="readcms">
    <template v-if="this.error">
      <div class="error">
        <strong>{{ this.error }}</strong>
      </div>
    </template>
    <template v-else>
      <template v-if="this.js_code != null">
        <div v-html="this.fullHtml" />
      </template>
      <template v-else>
        <div v-html="this.fullHtml" />
      </template>
    </template>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import TopPageApi from "@/general/api/topPageApi";

@Options({
  name: "SpecialPageDetail",
  props: {
	cms_response: { type: Object, default: null }
  }
})
export default class SpecialPageDetail extends Vue {
  cms_response!: object;

  data: any = null;
  sp_id = "";
  title = "";
  fullHtml = "";
  js_code = "";
  error = "";

  async mounted() {
    await this.readcms();
    if(this.js_code !== null) {
      this.jsGen();
    }
  }

  async created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.sp_id = urlParams.get("spid") || "";
    await this.readcms();
  }

  async readcms() {
    const APIres = await TopPageApi.getSpecialPage({
      sp_id: this.sp_id,
    });
    if (APIres.isError) {
      this.error = "コンテンツの読み込みに失敗しました"
    } else {
      return this.setData(APIres);
    }
  }

  setData(obj: any) {
    if (
        !obj ||
        !obj.data ||
        !obj.included ||
        !obj.included[0] ||
        obj.data.length >= 2
    ) {
      return this.error = "データが不正です。";
    }
    this.title = obj.data[0].attributes.display_title;
    this.$emit('catchTitle', this.title);
    this.js_code = obj.data[0].attributes.js_code;

    const dataId = obj.data[0].relationships.paragraphs.data[0].id;
    const includeData = obj.included.filter(
        (x:any) => x.id === dataId
    )

    const itemValue = includeData.find((el: { type: string; }) => el.type === "paragraph--full_html");

    if(!itemValue) {
      return this.error = "ご選択いただいたページは現在存在しないか、ご利用いただけません。";
    }
    this.fullHtml = itemValue.attributes.field_fullhtml_text.value;
  }

  jsGen() {
    let str = this.js_code;
    let jqueryCode = new Function(str);
    setTimeout(() => {
      jqueryCode();
    }, 10);
  }
}
</script>

<style lang="scss" scoped>
.specialPageCarousel__more {
  text-align: right;
  font-size: 0.875rem;
}
img {
  width: 100%;
  height: 160px;
  display: block;
}

.section-title {
  text-transform: uppercase;
  color: gold;
  border-bottom: 1px solid #222;
  padding-bottom: 1rem;
  margin-bottom: 2rem;
}
@media (min-width: 500px) {
  .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 2rem;
  }
}

@media (min-width: 800px) {
  .grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.grid-group {
  margin-bottom: 3rem;
}
@media (min-width: 500px) {
  .grid-group {
    margin-bottom: 0;
  }
}

.grid-group-meta {
  margin: 2rem 0;

  h3,
  h4 {
    margin: 0;
  }
  h3 {
    margin-bottom: 0.5rem;
    text-transform: uppercase;
  }
  h4 {
    font-style: italic;
  }
}
.grid-group-text {
  p {
    line-height: 1.5;
    text-align: justify;
  }
}
</style>
